import Lottie from "lottie-react";
import React, { useEffect } from "react";
import Footer from "../../Shared/Footer/Footer";
import NavigationBar from "../../Shared/NavigationBar/NavigationBar";
import "./SoftwareSolution.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faBookOpen,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import softJson from "./software-json.json";
import softJson1 from "./soft2-json.json";
import softTabimg1 from "../../../Images/Product & Services/Software/cripton.png";
import softTabimg2 from "../../../Images/Product & Services/Software/micorsoft.png";
import softTabimg3 from "../../../Images/Product & Services/Software/vmware.png";
import softTabimg4 from "../../../Images/Product & Services/Software/veritas.png";
import softTabimg5 from "../../../Images/Product & Services/Software/veeam.png";
import softTabimg6 from "../../../Images/Product & Services/Software/trend.png";
import { Parallax } from "react-parallax";
import lowerBg from "../../../Images/Product & Services/Software/soft-lower-bg.png";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
const SoftwareSolution = () => {
  // Button
  const handleClickCustom = () => {
    window.location.href = "tel:+8801713060441";
  };

  // MUI
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <div>
        <NavigationBar />
      </div>
      <section id="surveillance-herder-section">
        <div className="container container-fluid">
          <div className="row">
            <div className="col-12  justify-content-end surveillance-Lottie-div">
              <Lottie
                animationData={softJson}
                loop={true}
                className="surveillance-Lottie"
              />
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 surveillance-head-text-div">
              <div className="surveillance-tags-line">
                <p className="surveillance-tag">Software &</p>
                <h6 className="surveillance-tag-span">SOLUTIONS</h6>
              </div>
              <div className="surveillance-p1-div">
                <p className="surveillance-p1">
                  Software is an essential component of modern technology, and
                  software solutions can provide effective solutions to a wide
                  range of problems. By automating tasks, improving
                  collaboration, and providing valuable insights, software can
                  help businesses and individuals become more productive and
                  efficient. As technology continues to evolve, we can expect to
                  see even more innovative software solutions that will help us
                  work smarter and achieve our goals more effectively. Software
                  solutions is their ability to automate repetitive tasks,
                  allowing users to focus on more valuable work. For example, a
                  marketing team can use marketing automation software to
                  streamline their campaigns and reduce the time and effort
                  needed to carry out various tasks. Similarly, a customer
                  service team can use a ticketing system to manage customer
                  requests more efficiently, reducing the workload on individual
                  agents.
                </p>
              </div>
              <div className="surveillance-buttons-div">
                <button
                  onClick={handleClickCustom}
                  className=" btn btn-lg  surveillance-button-demo"
                >
                  <span className="me-2">
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  CALL FOR APPOINMENT AND DEMO
                </button>
                <button className=" btn btn-lg  surveillance-button-discover">
                  <span className="me-2">
                    <FontAwesomeIcon icon={faBookOpen} />
                  </span>
                  DISCOVER CASE STUDIES
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container container-fluid" id="tabs-mui">
        <div className="row">
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              height: 304,
            }}
          >
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderColor: "divider" }}
              >
                <Tab
                  className="pe-5"
                  label="Business Automation"
                  {...a11yProps(0)}
                />
                <Tab className="pe-5" label="Microsoft" {...a11yProps(1)} />
                <Tab className="pe-5" label="VMware" {...a11yProps(2)} />
                <Tab className="pe-5" label="Veritas" {...a11yProps(3)} />
                <Tab className="pe-5" label="Veeam" {...a11yProps(4)} />
                <Tab className="pe-5" label="Trend Micro" {...a11yProps(5)} />
              </Tabs>
            </div>
            <TabPanel value={value} index={0}>
              <div className="row">
                <div className=" col-5 tab-cams-div">
                  <img className="tabs-cams" src={softTabimg1} alt="" />
                </div>
                <div className="col-7">
                  <p>
                    We are providing the end to end IP CCTV Solution for Medium
                    and Large Enterprise Clients.
                  </p>
                  <ul>
                    <li>NVR or Server bases IP CCTV Solution.</li>
                    <li>Thermal Camera Solution.</li>
                    <li>Face Detection Access Contro</li>
                  </ul>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <div className="row">
                <div className="col-5 tab-cams-div">
                  <img className="tabs-cams" src={softTabimg2} alt="" />
                </div>
                <div className="col-7">
                  <p>
                    ZKTeco Co., Ltd is a globally renowned enterprise with
                    biometric verifications as its core technique.
                  </p>
                  <ul>
                    <li>Biometrics Attendance system</li>
                    <li>
                      {" "}
                      Face Detection Access Control and Attendance system
                    </li>
                    <li>Archway Gate and metal Detector</li>
                    <li>Gate Barrier System</li>
                  </ul>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <div className="row">
                <div className="col-5 tab-cams-div">
                  <img className="tabs-cams" src={softTabimg3} alt="" />
                </div>
                <div className="col-7">
                  <p>
                    The Garrett is an USA based Company. The company has set
                    goals to empower their customers with better products,
                    better technology and better information.
                  </p>
                  <ul>
                    <li>Archway Gate and metal Detector</li>
                    <li> Gate Barrier System</li>
                  </ul>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <div className="row">
                <div className=" col-5 tab-cams-div">
                  <img className="tabs-cams" src={softTabimg4} alt="" />
                </div>
                <div className="col-7">
                  <p>
                    Suprema is a leading global provider of access control, time
                    & attendance, and biometrics solutions.
                  </p>
                  <ul>
                    <li>Biometrics Attendance system</li>
                    <li>
                      {" "}
                      Face Detection Access Control and Attendance system
                    </li>
                  </ul>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={4}>
              <div className="row">
                <div className="col-5 tab-cams-div">
                  <img className="tabs-cams" src={softTabimg5} alt="" />
                </div>
                <div className="col-7">
                  <p>
                    PA system are announcements of movements at large area with
                    many speakers are widely used to make announcements in
                    public, institutional and commercial buildings and
                    locations.
                  </p>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={5}>
              <div className="row">
                <div className="col-5 tab-cams-div">
                  <img className="tabs-cams" src={softTabimg6} alt="" />
                </div>
                <div className="col-7">
                  <p>
                    PA system are announcements of movements at large area with
                    many speakers are widely used to make announcements in
                    public, institutional and commercial buildings and
                    locations.
                  </p>
                </div>
              </div>
            </TabPanel>
          </Box>
        </div>
      </section>

      <section>
        <div className="software-paralla-div1">
          <Parallax
            className="software-paralla"
            blur={2}
            bgImage={lowerBg}
            bgImageAlt="background-image"
            strength={70}
          >
            <div className="software-lottie-softjson1-full-div2 container">
              <div className="software-lottie-softjson1-div2">
                <Lottie
                  animationData={softJson1}
                  loop={true}
                  className="softwa-lottie-softjson1"
                />
              </div>
              <h3>
                Want to build a custom software solution that agile with your
                business?{" "}
              </h3>
            </div>
          </Parallax>
        </div>
      </section>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default SoftwareSolution;
